import type React from 'react'

export function PremiumIcon({
  width = 40,
  height = 40,
}: {
  width?: number
  height?: number
}) {
  return (
    <svg
      aria-label="Premium"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      role="img"
    >
      <title>Premium Icon</title>
      <path
        d="M2.08008 6.74999L2.13008 6.60999C2.26008 6.21999 2.60008 5.95999 3.02008 5.92999C3.40008 5.89999 3.78008 6.12999 3.96008 6.47999C4.14008 6.83999 4.09008 7.25999 3.83008 7.56999C3.80008 7.59999 3.77008 7.63999 3.73008 7.67999C4.47008 8.12999 5.20008 8.57999 5.93008 9.02999C6.21008 9.19999 6.49008 9.36999 6.76008 9.53999C6.92008 9.62999 7.04008 9.60999 7.13008 9.44999C7.98008 7.89999 8.82008 6.36999 9.67008 4.81999C9.30008 4.62999 9.07008 4.34999 9.04008 3.92999C9.03008 3.62999 9.13008 3.37999 9.34008 3.17999C9.76008 2.77999 10.4401 2.80999 10.8001 3.25999C11.2201 3.76999 11.0701 4.37999 10.4001 4.82999C10.6201 5.22999 10.8401 5.62999 11.0601 6.01999L12.8901 9.34999C13.0301 9.60999 13.1201 9.62999 13.3701 9.47999C14.3101 8.89999 15.2601 8.31999 16.2001 7.74999C16.2401 7.71999 16.2901 7.69999 16.3401 7.65999C16.1401 7.45999 16.0201 7.23999 16.0101 6.96999C15.9801 6.45999 16.3301 6.01999 16.8201 5.92999C17.3301 5.83999 17.8001 6.12999 17.9601 6.62999C17.9701 6.66999 17.9901 6.70999 18.0001 6.74999V7.09999C17.8401 7.60999 17.5101 7.90999 16.9401 7.91999L16.8801 8.09999C16.3301 9.98999 15.7701 11.89 15.2201 13.79C15.1501 14.04 15.0601 14.1 14.8101 14.1H5.28008C5.01008 14.1 4.93008 14.04 4.86008 13.79L3.51008 9.16999C3.39008 8.74999 3.27008 8.33999 3.14008 7.91999C2.72008 7.91999 2.40008 7.74999 2.20008 7.38999C2.15008 7.29999 2.12008 7.19999 2.08008 7.10999V6.74999ZM10.0001 15.94H14.4601C14.8601 15.94 15.1701 16.17 15.2201 16.48C15.2601 16.79 15.0101 17.08 14.6301 17.15C14.5801 17.16 14.5201 17.16 14.4601 17.16H5.54008C5.20008 17.16 4.91008 16.99 4.82008 16.74C4.72008 16.49 4.81008 16.2 5.08008 16.06C5.22008 15.99 5.41008 15.94 5.57008 15.94H10.0001Z"
        fill="#FDD577"
      />
    </svg>
  )
}
